// file serves purpose for storing key value pair for localization.
var locale = {
    'cFind': 'Find',
    'cReset': 'Reset',
    'cEnrolleeNoTimeline': 'No Timeline data for requested timespan',
    'cId': 'Id',
    'cEventId': 'Event Id',
    'cEnrolleeSearch': 'Enrollee Search',
    'cEnrolleeFindEnrollees': 'Find Enrollees',
    'cEnrolleeAdvanceSearch': 'Advanced Enrollee Search',
    'cEnrolleeFindVictims': 'Find Victims',
    'cEventFindEvents': 'Find Events',
    'cZoneFindZones': 'Find Zones',
    'cAnalysisFindIncidents': 'Find Incidents',
    'cAnalysisFindMatches': 'Find Matches',
    'cReportFindReports': 'Find Reports',
    'cInventoryFindDevices': 'Find Devices',
    'cInventoryFindBBG': 'Find BLUbox Groups',
    'cAgentFindAgents': 'Find Agents',
    'cAgentFindEscalationPlans': 'Find Escalation Plans',
    'cAgentFindEnrolleesCaseload': 'Find Enrollees in Caseload',
    'cAgentFindMyZones': 'Find Zones',
    'cEnrolleeGender': 'Gender',
    'cEnrolleeRace': 'Race',
    'cEnrolleeHairColor': 'Hair Color',
    'cEnrolleeEyeColor': 'Eye Color',
    'cEnrolleeMarksAndTattoos': 'Marks and Tattoos',
    'cEnrolleeVehicleYear': 'Vehicle Year',
    'cEnrolleeLicencePlateNumber': 'Vehicle Plate Number',
    'cEnrolleeVehicleColor': 'Vehicle Color',
    'cEnrolleeVehicle': 'Vehicle Make',
    'cEnrolleeVehicleModel': 'Vehicle Model',
    'cEnrolleeBLUtagInternational': 'BLUtag International',
    'cEnrollees': 'Enrollees',
    'cEnrollee': 'Enrollee',
    'cEvents': 'Events',
    'cEvent': 'Event',
    'cZones': 'Zones',
    'cZone': 'Zone',
    'cAnalysis': 'Analysis',
    'cReports': 'Reports',
    'cInventory': 'Inventory',
    'cAgents': 'Agents',
    'cAgent': 'Agent',
    'cUsers': 'Users',
    'cEnrolleeMyCaseload': 'My Caseload',
    'cEnrolleeCaseloadType': 'Caseload Type',
    'cEnrolleeOpenEvents': 'Open Events',
    'cEnrolleeHeight': 'Height',
    'cEnrolleeHeightCm': 'Height(cm)',
    'cEnrolleeName': 'Name',
    'cEnrolleeOrganization': 'Organization',
    'cEnrolleeAgency': 'Agency',
    'cEnrolleePrimaryId': 'Primary Id',
    'cEnrolleeSecondaryId': 'Secondary Id',
    'cAgentPrimaryAgent': 'Primary Agent',
    'cEventScope': 'Scope',
    'cEnrolleeStatus': 'Status',
    'cEventHits': 'Hits',
    'cEnrolleeIsEnrollink':'Is Enrollink',
    'cEnrolleeIsAssigned': 'Is Assigned',
    'cEnrolleeRiskLevel': 'Risk Level',
    'cEnrolleeArchived': 'Archived',
    'cEventAllActionableEvents': 'All Actionable Events',
    'cEventType': 'Event Type',
    'cEventAgentOfRecord': 'Agent of Record',
    'cEventIsOpen': 'Is Open',
    'cEnrolleeActivelyAssigned': 'Actively Assigned',
    'cEventLongerThan': 'Longer Than',
    'cEventMethod': 'Method',
    'cEventFormat': 'Format',
    'cEventTime': 'Time',
    'cEventStartDate': 'Start Date',
    'cEventStopDate': 'Stop Date',
    'cEventStop': 'Stop',
    'cEventConfirmedDate': 'Confirmed Date',
    'cEventConfirmed': 'Confirmed',
    'cEventIsConfirmed': 'Is Confirmed',
    'cEventConfirmedBy': 'Confirmed By',
    'cEventConfirmedOn': 'Confirmed On',
    'cEventNewNote': 'New Note...',
    'cEventNotes': 'Notes',
    'cEventTotalPoints': 'Total Points',
    'cZonePoints': 'Zone Points',
    'cEventMENotes': 'Monitored Event Notes',
    'cEventMonitoredEvent': 'Monitored Event Instant Report',
    'cEnrolleeDescription': 'Description',
    'cEnrolleeResults': 'Results',
    'cAnalysisStart': 'Start',
    'cAnalysisEnd': 'End',
    'cSundayLetter': 'S',
    'cMondayLetter': 'M',
    'cTuesdayLetter': 'T',
    'cWednesdayLetter': 'W',
    'cThursdayLetter': 'R',
    'cFridayLetter': 'F',
    'cSaturdayLetter': 'S',
    'cAgentContactMethod': 'Contact Method',
    'cAgentContactInterval': 'Contact Interval',
    'cAgentEscalationPlan': 'Escalation Plan',
    'cType': 'Type',
    'cEnrolleePayTransactionDate': 'Transaction Date',
    'cEnrolleePayPaymentType': 'Payment Type',
    'cEnrolleePayRefNumber': 'Reference Number',
    'cEnrolleePayAmount': 'Amount',
    'cEnrolleePayTaxAmount': 'Tax Amount',
    'cEnrolleePayTotalAmount': 'Total Amount',
    'cEnrolleePayUpdate': 'Updating Enrollee Pay program...',
    'cEnrolleePayUpdateFailed': 'Enrollee Pay failed...',
    'cEnrolleeProduct': 'Product',
    'cEnrolleeSerialNumber': 'Serial Number',
    'cSerialNumber': 'Serial Number',
    'cEnrolleeStartDate': 'Start Date',
    'cEnrolleeEndDate': 'End Date',
    'cEnrolleeStopDate': 'Stop Date',
    'cEnrolleeChangeReason': 'Reason for Change',
    'cEnrolleeChargerReturnStatus': 'Charger Return Status',
    'cEnrolleeZoneScheduleType': 'Zone Category',
    'cEnrolleeScheduleType': 'Schedule Type',
    'cEnrolleeScheduleTarget': 'Schedule Target',
    'cEnrolleeScheduleTargetType': 'Target Type',
    'cEnrolleeDateTime': 'Date/Time',
    'cEnrolleeCheckIn': 'Check In',
    'cEnrolleePoints': 'Points',
    'cInventoryRecords': 'Records',
    'cInventoryGPS': 'GPS',
    'cInventoryPercentGPS': 'Percent GPS',
    'cInventoryBatteryLevel': 'Battery Level',
    'cInventoryBatteryVoltage': 'Voltage',
    'cInventoryDeviceStatus': 'Device Status',
    'cInventoryDevice': 'Device',
    'cInventorySerialProduct': 'Serial # /<br/> Product',
    'cInventoryStatusOrganization': 'Status /<br/>Organization',
    'cReportIsRequired': 'Is Required',
    'cReportValue': 'Value',
    'cEnrolleeAddNewSchedule': 'Add New Schedule',
    'cEnrolleeEditSchedule': 'Edit Schedule',
    'cAnalysisCaseNumber': 'Case Number',
    'cAnalysisIncidentNumber': 'Incident Number',
    'cEnrolleePrimaryOffense': 'Primary Offense',
    'cAnalysisDisposition': 'Disposition',
    'cZoneIsMine': 'My Zones',
    'cZoneType': 'Type',
    'cZoneShape': 'Shape',
    'cZoneScope': 'Scope',
    'cDashboardColumn': 'Column',
    'cDashboardAbbr': 'Abbr',
    'cDashboardUpDown': 'Up/Down',
    'cDashboardSortOrder': 'Sort Order',
    'cEnrolleeFindMapObjects': 'Find Map Objects',
    'cEnrolleeDisplay': 'Display',
    'cZoneZonesSmallerThan': 'Zones Smaller Than',
    'cZone250': '250 ft',
    'cZone500': '500 ft',
    'cZone750': '750 ft',
    'cZone1000': '1000 ft',
    'cZone1500': '1500 ft',
    'cZone5280': '1 mile',
    'cDashboardLastTrack': 'Last Track',
    'cEnrolleeSave': 'Save',
    'cEnrolleeUpdate': 'Update',
    'cEnrolleeDisable': 'Disable',
    'cEnrolleeEdit': 'Edit',
    'cEnrolleeDelete': 'Delete',
    'cEnrolleeCancel': 'Cancel',
    'cEnrolleeRemove': 'Remove',
    'cEnrolleeClose': 'Close',
    'cEnrolleeContinue': 'Continue',
    'cEnrolleeRestart': 'Restart',
    'cEnrolleeChange': 'Change',
    'cEnrolleeAssignment': 'Assignment',
    'cEnrolleeAddToMap': 'Add To Map',
    'cEnrolleAddAllToMap':'Add All To Map',
    'cEnrolleeRemoveFromMap': 'Remove From Map',
    'cEnrolleeAddSecondaryOffender': 'Add Secondary Enrollee',
    'cEventAddCaseNotes': 'Add Case Note',
    'cEventConfirm': 'Confirm',
    'cEventConfirmFor': 'Confirm for',
    'cEventConfirmEventsFor': 'Confirm Events for',
    'cEventConfirmEvent': 'Confirm Event',
    'cEventConfirmedBy': 'Confirmed By',
    'cEventConfirmedOn': 'Confirmed On',
    'cEventHasNotes': 'Has Notes',
    'cDashboardEditColFav': 'Edit Column Favorites',
    'cEnrolleeAddNewNote': 'Add New Note',
    'cEnrolleeMobileAppImage': 'Image',
    'cEnrolleeMobileAppCheckIn': 'Location Verification',
    'cEnrolleeMobileAppPassed': 'Passed',
    'cEnrolleeMobileAppCheckInTime': 'Verification Time',
    'cEnrolleeMobileAppCheckInId': 'Id',
    'cEnrolleeMobileAppLocation': 'Location',
    'cEnrolleeMobileAppConfirmOnDemand': 'Location Verification On Demand Request',
    'cEnrolleeMobileAppSelfReport': 'Self Reported Profile Update Request',
    'cEnrolleeMobileAppQuestionnaire': 'Questionnaire',
    'cEnrolleeMobileAppScheduleRequest': 'Time Out Schedule Request',
    'cEnrolleeMobileAppRequestQuestionnaire': 'Request New answers',
    'cEnrolleeMobileAppRequestAgentResponseTitle': 'Approval/denial confirmation',
    'cEnrolleeMobileAppVideoCall': 'Video Call',
    'cEnrolleeAddNote': 'Add Note',
    'cEnrolleeAddressStreet1': 'Street 1',
    'cEnrolleeAddressStreet2': 'Street 2',
    'cEnrolleeAddressCity': 'City',
    'cEnrolleeAddressState': 'State',
    'cEnrolleeAddressZipCode': 'Zip Code',
    'cEnrolleeAddressCountry': 'Country',
    'cEnrolleeAdditionalInfo': 'Additional Info',
    'cEnrolleePhone': 'Phone',
    'cEnrolleeAltPhone': 'Alt Phone',
    'cEnrolleeNotes': 'Notes',
    'cTitle': 'Title',
    'cEnrolleeSpeed': 'Speed',
    'cEnrolleeAddressDeleteContinue': 'Click Continue to delete this address.',
    'cEnrolleeAddress': 'Address',
    'cEnrolleeAddressAutoFill': 'Auto Fill',
    'cEnrolleeAddAddress': 'Add Address',
    'cEnrolleeEditAddress': 'Edit Address',
    'cEnrolleeDeleteAddress': 'Delete Address',
    'cEnrolleeDetails': 'Details',
    'cEnrolleeLatitude': 'Latitude',
    'cEnrolleeLongitude': 'Longitude',
    'cEnrolleeBluBoxNotification': 'BLUBox Notification',
    'cEnrolleeBluBoxMoveNotification': 'The enrollee’s home address has already been confirmed.  Saving this updated address will automatically reassign your BLU+ resulting in the location of the BLUbox needing to be re-verified. ',
    'cEnrolleeBluBoxMoveNotificationProceed': 'Do you want to proceed with saving the updated home address?',
    'cEnrolleeEditMode': 'Edit Mode',
    'cEnrolleeEditOffenderLabel': 'Edit Label',
    'cEnrolleeOffenderLabelName': 'Label Name',
    'cEnrolleeChangeDeviceAssignReason': 'Change Device Assignment Reason',
    'cEnrolleeRemoveDeviceAssign': 'Remove Device Assignment',
    'cReason': 'Reason',
    'cInventoryTrackChargerReturnStatus': 'Track Charger Return Status',
    'cInventoryChargerStatus': 'Charger Status',
    'cInventoryChargerBroken': 'Returned - Broken',
    'cInventoryChargerOk': 'Returned - Ok',
    'cInventoryChargerMissing': 'Not Returned',
    'cInventoryEditDevices': 'Edit Devices',
    'cEnrolleePaySummaryFor': 'Enrollee Pay Summary for ',
    'cIncidentsRunningSpatialQuery': 'Running spatial query..... This may take a while.',
    'cIncidentsSpatialQueryNoResults': 'Spatial query did not return any results, try again.',
    'cIncidentsSpatialSearch': 'Spatial Search',
    'cEnrolleeGoEnrollee': 'Enrollee Maps',
    'cEnrolleeNavigateSpatial': ' Navigating away will not save your search. Are you sure you want to navigate to enrollee before saving?',
    'cEnrolleeAreYouSure': 'Are you sure?',
    'cAgentContactAgent': 'Contact Agent',
    'cAgentSend': 'Send',
    'cAgentChangeSchema': 'Change Schema',
    'cAgentChange': 'Change',
    'cError': 'Error',
    'cZoneGlobalAssignedScopeError': 'Scope cannot be set to global while the zone is assigned to Enrollees',
    'cOk': 'OK',
    'cAgentAddNotifications': 'Add Notifications',
    'cAgentEditNotification': 'Edit Notification',
    'cEnrolleeNotificationSetup': 'Notification Setup',
    'cEnrolleeVictimNotFinished': ' Victim creation has not yet finished, please wait a few more minutes.',
    'cEnrolleeMasterScheduleName': 'Master Schedule Name: ',
    'cEnrolleeSaveAbsenceSchedulesFor': 'Save Absence Schedule for',
    'cEnrolleeEditAbsence': 'Edit Absence',
    'cEnrolleeLegend': 'Legend',
    'cEnrolleeTimeline': 'Timeline',
    'cEnrolleeFRP': 'Financial Responsible Party',
    'cEnrolleeFRPByPassGeocode': 'Bypass Geocoding',
    'cEnrolleeCurrentFRP': 'Current FRP',
    'cEnrolleeFirstName': 'First Name',
    'cEnrolleeLastName': 'Last Name',
    'cAgentEmail': 'Email',
    'cEnrolleeEidSettings': 'EID Settings',
    'cEnrolleeBluPlusConfiguration': 'BLU+ Configuration',
    'cEnrolleeBluHomeConfiguration': 'BLUhome Configuration',
    'cEnrolleeLoading': 'Loading',
    'cEnrolleeLatestAssociations': 'Latest Associations',
    'cEnrolleeAssociations': 'Associations',
    'cInventoryPostMessage': 'Post Message',
    'cInventoryClearMessage': 'Clear Message',
    'cInventoryBluHomeMessageManager': 'BLUhome Message Manager',
    'cInventoryBluHomeSendTopLabel': 'Top Line (16 Chars Max):',
    'cInventoryBluHomeSendBottomLabel': 'Bottom Line (16 Chars Max):',
    'cInventoryBluHomeSendMessage': 'This tool will allow ou to post a short message on the front of Enrollee\'s BLUhome. It will be displayed in two 16 character lines which you can define below. Click the Post Message button to send the message to the BLUhome. Click the Clear Message button to clear any previous message that may be on the BLUhome.',
    'cEnrolleeCalendarSchedule': 'Enrollee Calendar Schedule',
    'cEnrolleeViewAbsenceSchedules': 'View Absence Schedules',
    'cEnrolleeReoccurring': 'Recurring',
    'cAgentChangeLogonDetails': 'Change logon details',
    'cAgentParentOrganizationWarning': 'You are logging into a Parent Organization. Veritracks is going to attempt to load all ',
    'cAgentParentOrganizationChildLoadWarning': ' Child Organizations under this Parent Organization. This may be time consuming and could result in degraded system performance.',
    'cAgentWarning': 'Warning',
    'cAgentContactUs': 'Contact Us',
    'cAgentContactSolutionsCenter': '<p>Contact our Solutions Center for technical support.</p><p>   E-mail: techsupport@securusmonitoring.com  </p><p> Toll-Free: 1-866-703-7867 </p>',
    'cAgentSubmit': 'Submit',
    'cAgentProvideFeedback': 'Provide Feedback',
    'cEnrolleeRetrieveArchive': 'Retrieve from Archive',
    'cEnrolleeSearchArchive': 'Search Enrollee Archive',
    'cAgentLoginIncorrectInfo': 'Incorrect Information',
    'cAgentNewPassword': 'New Password',
    'cAgentConfirmPassword': 'Confirm Password',
    'cAgentSecurityQuestion': 'Security Question',
    'cAgentSecurityAnswer': 'Security Answer',
    'cAgentLoginRequiredInformation': 'Please fill in the required information',
    'cInventoryDeviceActionFailed': 'Device Action Read Failed',
    'cEnrolleeComplete': 'Complete',
    'cAgentSessionExpiredMessage': 'The session has expired. You are being redirected to the login page.',
    'cDefaultCacheErrorRetry': 'Error retrieving cachable items. System will retry.',
    'cDefaultServerErrorRetry': 'Server not ready. System will retry.<br />Initializing items.',
    'cAgentFeedbackReceived': 'Your feedback has been received. Thank you.',
    'cAgentSavingFeedback': 'Saving feedback...',
    'cEnrolleeSuccessRetrievedArchive': 'Succesfully retrieved archived enrollees.',
    'cInventoryDeviceActionSent': 'Device Action Sent.',
    'cAgentChangeSMSError': 'Changing SMS option requires a phone number to be provided.....',
    'cAgentSMSMessageSuccess': 'Did you get a message?',
    'cAgentZoneMoveSuccess': 'Zones moved successfully!!',
    'cAgentZoneMoveFailed': 'Zones move failed....',
    'cAgentBluBoxGroupMoveSuccess': 'BLUbox group moved successfully!!',
    'cAgentBluBoxGroupMoveFailed': 'BLUbox group moved failed.....',
    'cAgentCaseloadMoveSuccess': 'Caseload moved successfully.',
    'cAgentCaseloadMoving': 'Moving Caseload to: ',
    'cAgentEnrolleeAdditionalSuccess': 'Additional enrollees added successfully.',
    'cAgentEnrolleeAdditionalAdding': 'Adding additional enrollees. This may take a few minutes.',
    'cAgentEnrolleesRemovedAdditionalSuccess': 'Additional enrollees removed successfully.',
    'cAgentEnrolleeAdditionalRemoving': 'Removing additional enrollees. This may take a few minutes.',
    'cAgentDailyNotificationSameScopeError': 'Daily Notification with same event and scope cannot be created.',
    'cAgentDailyNotificationAlreadyExists': 'Daily Notification already exists.',
    'cAgentImmediateNotificationAlreadyExists': 'Immediate Notification already exists.',
    'cAgentNotificationAlreadyExists': 'Notification already exists.',
    'cAgentSendEmailAgent': 'Sending Email to Agent: ',
    'cAgentLoadingEscalationPlans': 'Loading Escalation Plans.',
    'cEnrolleeUnknownEnrollee': 'Unknown Enrollee',
    'cAgentMessageSent': 'Message sent',
    'cAnalysisSpatialQueryLoading': 'Objects to run a spatial search are still loading. Please wait.',
    'cAnalysisSpatialQueryWait': 'Running spatial query..... This may take a while.',
    'cAnalysisSpatialQueryNoResults': 'Spatial query did not return any results.',
    'cDefaultNoResultsFound': 'No results found',
    'cAnalysisSpatialQueryFailed': 'Spatial Query failed. Please try again.',
    'cAnalysisSpatialQueryRadiusLarge': 'Radius exceeds half a mile. Cannot run spatial query. Set to max.',
    'cAnalysisPointOfInterestRadiusLarge': 'Radius exceeds a mile. Cannot use more than one mile.',
    'cAnalysisDeleteEnrolleeMatch': 'Deleting from matches Enrollee: ',
    'cAnalysisEnableEnrolleeMatch': 'Enabling from matches  Enrollee: ',
    'cAnalysisNoMatchesNoSave': 'Cannot save without matches.',
    'cAnalysisNoResultsFoundEditSearch': 'No results were found, please edit your search',
    'cAnalysisIncidentSaveError': 'Error saving incident.',
    'cAnalysisIncidentAlreadyExists': 'Incident number already exists.',
    'cAnalysisIncidentMatchSaving': 'Saving incident matches with incident number: ',
    'cAnalysisIncidentSaving': 'Saving incident: ',
    'cAnalysisIncidentSaved': ' Saved Incident: ',
    'cDefaultCenteringAddress': 'Centering on address: ',
    'cDefaultAddressNotGeocoded': 'Address could not be geocoded.',
    'cDefaultCenteringLatLong': 'Centering on LatLong: ',
    'cAnalysisIncidentSaveFailed': 'Incident save failed',
    'cDefaultRefreshing': 'Refreshing....',
    'cEnrolleeLastTrackRefreshing': 'Last Track Popup refreshing....',
    'cEnrolleeSaveNoteFor': 'Saved note for ',
    'cEnrolleeSaveCustomReport': 'Saved custom report ',
    'cEnrolleeConfirmationEventNotes': 'Wrote confirmation event notes for ',
    'cEnrolleeConfirmedEventsFor': 'Confirmed events for ',
    'cEnrolleeUpdatedCustomReport': 'Updated custom report ',
    'cEnrolleeReportSortOrderUpdate': 'Updated sort order for custom report ',
    'cEnrolleeVictimOffenderPairComplete': 'Enrollee - Victim Assignment Complete!',
    'cEnrolleeVictimOffenderUnPairComplete': 'Enrollee - Victim Unpairing Complete!',
    'cZoneClassifiedZoneSave': 'Classified Zone saved with ID: ',
    'cZoneClassifiedZoneFail': 'Classified Zone failed with ID: ',
    'cZoneVertexZoneSave': 'Vertex Zone saved ',
    'cZoneZoneSave': 'Saved Zone: ',
    'cZoneZoneSaveError': 'Error saving zone ',
    'cPOISaveErrorAlreadyExist': 'We are Sorry, that name already exists. Please try using a different name ',
    'cPOILabelSave': 'Saved Label: ',
    'cPOILabelSaveError': 'Error saving Area of Interest ',
    'cPOIAreaOfInterestSave': 'Saved Area of Interest: ',
    'cPOIAreaOfInterestSaveError': 'Error saving label ',
    'cZoneGlobalZoneSave': 'Global Zone saved with ID: ',
    'cEnrolleeNoteLengthError': 'Note must be 3000 characters or less.',
    'cEnrolleeBluBoxLocationOpened': 'BLUBox awaiting location confirmation event has been opened',
    'cEnrolleeAddressSaved': 'Saved Address: ',
    'cEnrolleeAddressTether': 'Authorized Address ',
    'cEnrolleeAddressSaveError': 'Address save error: ',
    'cZoneDuplicateNameError': 'Zone name already exists: ',
    'cEnrolleeScheduleSuccess': 'Schedule successfully created',
    'cEnrolleeScheduleFail': 'Schedule create failed',
    'cZoneSaving': 'Saving Zone: ',
    'cZoneDeleting': 'Deleting Zone: ',
    'cZoneNoMatch': 'No matching Zone found.',
    'cEnrolleeRemovedFromEid': 'Enrollee has been removed from EID.',
    'cEnrolleeEidQuotaFilled': 'EID enrollment quota has already been filled.',
    'cEnrolleeEidReservationUpdated': 'Enrollee EID Updated. ',
    'cEnrolleeEidReservationCreated': 'Enrollee EID Created. ',
    'cEnrolleeEidMonitoring': 'EID',
    'cEnrolleeEidQuota': 'EID Quota for ',
    'cInventoryDeviceGPSOnAction': 'Device action sent to turn GPS on.',
    'cInventoryDeviceGPSOffAction': 'Device action sent to turn GPS off.',
    'cEnrolleeAdressReadFailed': 'Address read failed',
    'cEnrolleeVisitLabelReadFailed': 'Visit label read failed',
    'cEnrolleeTrackpointsDisplayed': 'Trackpoints Displayed',
    'cEventNoteAdded': 'Note added.',
    'cEventGetMapData': 'Getting map data.',
    'cEventEventConfirmed': 'Event confirmed.',
    'cEventStrapConfirmProblem': 'Event cannot be confirmed until strap fixed.',
    'cInventorySavedDeviced': 'Saved Device #',
    'cInventoryBluBoxUnlockedSuccess': 'BLUbox Group unlocked successfully.',
    'cInventoryBluBoxUnlockFail': 'Unable to unlock BLUbox Group.',
    'cInventoryDeviceListSaved': 'Device list saved.',
    'cInventoryBluBoxGroupSave': 'Saved BLUbox Group: ',
    'cReportAddAvailable': 'You can now add reports!!!',
    'cReportFinishedProcessing': 'Report has finished processing.',
    'cReportNoItemsForFilter': 'No items found for filter.',
    'cReportLoading': 'Loading Reports.',
    'cReportSaving': 'Saving Report: ',
    'cReportRequiredFiledNotice': 'Please complete all required fields.',
    'cReportGetDetailsFailed': 'Get Report Details Failed',
    'cReportProcessSaveSuccess': 'Report Process update save success',
    'cReportProcessSaveFailed': 'Report Process update save failed',
    'cReportReportsFilterFailed': 'Report Filter save failed',
    'cReportSaveFail': 'Report save failed',
    'cReportFilterUnknownError': 'ERROR:  Unkown Filter Type.',
    'cReportIncidentInsReportSaving': 'Saving Incident Instant Report.',
    'cReportIncidentInsReportSaveSuccess': 'Incident Instant Report Success.',
    'cReportEnrolleeProfileInsSaving': 'Saving Enrollee Profile Instant Report.',
    'cReportEnrolleeProfileInsSuccess': 'Enrollee Profile Instant Report Success.',
    'cReportEnrolleeScheduleInsSaving': 'Saving Enrollee Schedule Instant Report.',
    'cReportEnrolleeScheduleInsSuccess': 'Enrollee Schedule Instant Report Success.',
    'cReportSaveFailed': 'Report save failed',
    'cReportMonitoredInsReportSaving': 'Saving Monitored Event Instant Report.',
    'cReportMonitoredInsReportSaveSuccess': 'Monitored Event Instant Report Success.',
    'cReportEnrolleeEventInsReportSaving': 'Saving Enrollee Event Instant Report.',
    'cReportEnrolleeEventInsReportSaveSuccess': 'Enrollee Event Instant Report Success.',
    'cReportUpdateSuccess': 'Report update successful',
    'cReportUpdateFailed': 'Report update failed',
    'cDefaultGothimSaveFail': 'Gothim save failure.',
    'cEnrolleeAddOffenderToVictimMap': 'Adding enrollee to victim map: ',
    'cDefaultNetworkError': 'Network Error: ',
    'cEnrolleeZESLoaded': 'Zones, Events, and Schedules loaded',
    'cEnrolleeZESUnLoaded': 'Zones, Events, and Schedules unloaded',
    'cEnrolleeNoteNotSaved': 'Note not saved',
    'cEnrolleeScheduleCarveOutModeEnter': 'Entering carve out mode for ',
    'cEnrolleeImageNeedsOffenderCreate': 'Save enrollee first, then add images',
    'cEnrolleeAbsenceCreateQuestion': 'Do you not wish to create absences?',
    'cEnrolleeMasterScheduleNameRequired': 'Master Schedule needs a name, the others shall follow.',
    'cAgentDisableUnable': 'Unable to Disable Agent',
    'cAgentCorrectIssues': 'Please correct these issues',
    'cAgentContactsRemain': 'Agent escalation plan contacts remain',
    'cAgentZonesRemain': 'Zones remain.',
    'cAgentRiskLevelPlansRemain': 'Risk Level Plans remain',
    'cAgentProfilesRemain': 'Enrollee Profiles remain.',
    'cAgentNotificationsRemain': 'Notifications remain.',
    'cAgentContactTreesRemain': 'Contact Trees remain.',
    'cAgentOrganizationRemaining': '<h2>Not all Organizations removed</h2><div>Some Organizations may still have data attached to them. Please remove before trying again.</div>',
    'cAgentMoveEnrollees': 'Move Enrollees',
    'cAgentMoveMyZones': 'Move Zones',
    'cAgentAddAditionalEnrollees': 'Add Additional Enrollees',
    'cAgentAddDailyNotifications': 'Add Daily Notifications',
    'cAgentEditDailyNotifications': 'Edit Daily Notifications',
    'cAgentAddImmediateNotifications': 'Add Immediate Notifications',
    'cAgentEditImmediateNotifications': 'Edit Immediate Notifications',
    'cAgentAddOffHours': 'Add Off Hours',
    'cAgentEditOffHours': 'Edit Off Hours',
    'cAgentAddAgent': 'Add Agent',
    'cDefaultSessionTimeout': 'Session Timeout',
    'cDefaultSessionTimeoutRedirect': '<div>Session Has Timeout. You will be redirected to login.</div>',
    'cDefaultExtendSession': 'Extend Session',
    'cDefaultExtendSessionExpire': '<div>Your session is about to expire. To continue using the system, please click "Continue" below.</div>',
    'cEnrolleesEditEnrollees': 'Edit Enrollees',
    'cEnrolleesMappingVisit': 'Visit',
    'cEnrolleesMappingInProgress': 'In Progress',
    'cEnrolleesMappingTrackpoint': 'Trackpoint',
    'cEnrolleesMappingTrackpointCount': 'Trackpoint Count',
    'cEnrolleesMappingTrackpointCountTruncated': 'Count has been Truncated',
    'cEnrolleesMappingStart': 'Start:',
    'cEnrolleesMappingEnd': 'End:',
    'cEnrolleesMappingTag': 'Tag: ',
    'cEnrolleesMappingTag': 'Tag: ',
    'cEnrolleesMappingTrack': 'Track',
    'cEnrolleesMappingUnknown': '- unknown -',
    'cUpdateAvailable': 'Update Available',
    'cDashboardLastUpdate': 'Last update at ',
    'cPagerPage': 'Page',
    'cPagerItemsFound': ' items found.',
    'cPagerOf': ' of ',
    'cInventoryFindDevices': 'Find Devices',
    'cEnrolleeShowCopyAddress': 'show copy address',
    'cEnrolleeHideCopyAddress': 'hide copy address',
    'cNoMatchingRecords': 'No matching records.',
    'cEnrolleeRecurring': 'Recurring',
    'cEnrolleeOverride': 'Override',
    'cEnrolleeOneTime': 'One Time',
    'cNoData': '[No Data]',
    'cMonday': 'Monday',
    'cTuesday': 'Tuesday',
    'cWednesday': 'Wednesday',
    'cThursday': 'Thursday',
    'cFriday': 'Friday',
    'cSaturday': 'Saturday',
    'cSunday': 'Sunday',
    'cTo': 'to',
    'cFrom': 'from', //7133067178
    'cEnrolleeAbsenceReasonFor': 'Absence Reason For',
    'cAgentMyEnrollees': 'My Enrollees',
    'cAgentAgencysEnrollees': 'Agency\'s Enrollees',
    'cAgentPrimaryEmail': 'Primary Email',
    'cAgentSecondaryEmail': 'Secondary Email',
    'cAgentThirdContact': 'Third Contact',
    'cAgentPrimaryContact': 'First Contact',
    'cAgentSecondaryContact': 'Second Contact',
    'cAgentTertiaryContact': 'Third Contact',
    'cAgentContactConfirmFlag': 'Enable Notifications',
    'cAgentEscalationPlan': 'Escalation Plan',
    'cAgentOffHours': 'Off Hours',
    'cAgentNormalHours': 'Normal Hours',
    'cOrganizationChange': 'change',
    'cAgentHelp': 'help',
    'cAgentTraining': 'training',
    'cAgentFeedback': 'feedback',
    'cAgentContactUs': 'contact us',
    'cAgentLogout': 'logout',
    'cAgentStandarUser': 'Standard User',
    'cAgentSupervisor1': 'Supervisor 1',
    'cAgentSupervisor2': 'Supervisor 2',
    'cAgentSupervisor3': 'Supervisor 3',
    'cAgentSupervisor4': 'Supervisor 4',
    'cEnrolleeTimeZone': 'Time Zone',
    'cAgentIsDutyOfficer': 'Is Duty Officer',
    'cAgentThisAgentDutyOfficer': 'This agent is a duty officer',
    'cAgentSupervisorType': 'Supervisor Type',
    'cAgentDutyOfficer': 'Duty Officer',
    'cAgentNoDutyOfficer': 'No duty officer',
    'cEnrolleeScheduleNoEdit': 'Schedule is not editable',
    'cEnrolleeDeleteDay': 'Delete',
    'cEnrolleeDeleteAll': 'Delete All',
    'cEventOpen': 'Open',
    'cEventClosed': 'Closed',
    'cEventConfirmed': 'Confirmed',
    'cEventNotConfirmed': '-Not Confirmed-',
    'cUnknown': 'Unknown',
    'cEventNone': 'None',
    'cYes': 'Yes',
    'cNo': 'No',
    'cEnrolleeNotEnrolled': 'Not Enrolled',
    'cEventNoteText': 'Note text.',
    'cEnrolleeCurrentlyAssigned': 'Currently Assigned',
    'cEventExpired': 'Expired',
    'cEventUsed': 'Used',
    'cEventCanceled': 'Canceled',
    'cEnrolleeHome': 'Home',
    'cEnrolleeWork': 'Work',
    'cEnrolleeOther': 'Other',
    'cEnrolleeUnassigned': 'Unassigned',
    'cEnrolleeAssigned': 'Assigned',
    'cAgentEmail': 'Email',
    'cAgentUnset': '- unset -',
    'cAgentDeny': 'Deny',
    'cAgentRead': 'Read',
    'cAgentReadWrite': 'Read/Write',
    'cAgentGrant': 'Grant',
    'cInventoryActive': 'Active',
    'cInventoryPassive': 'Passive',
    'cInventoryHybrid': 'Hybrid',
    'cEnrolleeProxCaution': 'Proximity alert caution',
    'cEnrolleeProxWarning': 'Proximity alert warning',
    'cEnrolleeProxDanger': 'Proximity alert danger',
    'cEnrolleeProxCritical': 'Proximity alert critical',
    'cInventoryCritical': 'Critical',
    'cInventoryWarning': 'Warning',
    'cGood': 'Good',
    'cBad': 'Bad',
    'cEnrolleeTripsVisits': 'Trips & Visits',
    'cEnrolleeTrackpoints': 'Trackpoints',
    'cAgentNotEnabled': 'Not Enabled',
    'cAgentEnabled': 'Enabled',
    'cManual': 'Manual',
    'cAutomatic': 'Automatic',
    'cAgentPrimaryPhone': 'Primary Phone',
    'cAgentSecondaryPhone': 'Secondary Phone',
    'cEnrolleeEnrollmentNotificationUpToDate': 'Are you sure the following information are up to date?',
    'cEnrolleeEnrollmentDuration': 'Enrollment Duration',
    'cEnrolleeSchedules': 'Schedules',
    'cEnrolleeScheduleUpdateDate': 'Updated Date',

    'cEnrolleeEnrollmentUpToDate': 'Enrollment Information',
    'cCreateOverride': 'Create Override',
    'cZoneInclusion': 'Inclusion',
    'cZoneExclusion': 'Exclusion',
    'cEventHasMonitoredEvent': 'Has Monitored Event',
    'cEventViewNotes': 'view notes...',
    'cEnrolleeTestResults':'view checks',
    'cEnrolleeAddressStreet': 'Street',
    'cAnalysisAdditionalInformation': 'Additional Information',
    'cAnalysisAgencyCaseNumber': 'Agency Case Number',
    'cAnalysisRespondingOfficer': 'Responding Officer',
    'cAnalysisDisposition': 'Disposition',
    'cAnalysisClearedException': 'Cleared Exception',
    'cAnalysisClearedDate': 'Cleared Date',
    'cInventoryLastContact': 'Last Contact',
    'cInventoryContactDate': 'Contact Date',
    'cAnalysisTrackDate': 'Track Date',
    'cInventoryDirection': 'Direction',
    'cInventoryLatLng': 'Lat/Lng',
    'cInventoryDeviceVersion': 'Device Version',
    'cInventoryAssignmentHistory': 'Assignment History',
    'cInventoryContactHistory': 'Contact History',
    'cDashboard': 'Dashboard',
    'cEnrolleePay': 'Enrollee Pay',
    'cZoneRadius': 'Radius',
    'cZoneMappingVisibility': 'Mapping Visibility',
    'cZoneOverlayZone': 'Overlay Zone',
    'cViewSchedule': 'View Schedule',
    'cSchedule': 'Schedule',
    'cColumns': 'columns',
    'cInventoryLastContactDate': 'Last Contact Date',
    'cEnrolleeLastTrackDate': 'Last Track Date',
    'cEnrolleeSortDate': 'Sort Date',
    'cEventOpenClosed': 'Open/Closed',
    'cReportReportName': 'Report Name',
    'cSort': 'Sort',
    'cAscending': 'Ascending',
    'cDescending': 'Descending',
    'cAnalysisResults': 'Results',
    'cAnalysisIncidents': 'Incidents',
    'cAnalysisSpatialQuery': 'Spatial Query',
    'cZoneZoneDetail': 'Zone Details',
    'cZoneLocate': 'Locate',
	'cInventoryHDOP': 'HDOP',
	'cLocatedBy': 'Located By',
	'cMacAddress': 'MAC Address',
    'cSatellitesInView': 'Satellites In View',
    'cSatellitesUsed': 'Satellites Used',
    'cEventStrapTamper': 'Strap Tamper',
    'cEventLowBattery': 'Low Battery',
    'cEventOnCharger': 'On Charger',
    'cEventInclusionZone': 'In Inclusion Zone',
    'cEventExclusionZone': 'Exclusion Zone',
    'cEventNone': 'None',
    'cEventNotConfirmed2': 'Not Confirmed',
    'cEventInProgress': 'In Progress',
    'cEnrolleeTrackpointEvents': 'Trackpoint Events',
    'cZonesShowZones': 'Show Zones',
    'cEventLockStart': 'Lock Start Date',
    'cEnrolleeShowAddresses': 'Show Enrollee Addresses',
    'cEnrolleeShowConnectedTracks': 'Show Connected Tracks',
    'cEnrolleeShowNumberedLabels': 'Show Numbered Labels',
    'cEventShowEvents': 'Show Events',
    'cEnrolleeGpsTracks': 'Show GPS Trackpoints',
	'cEnrolleeCellTowerPoints': 'Show Cell Tower Trackpoints',
	'cEnrolleeWiFiPoints': 'Show Wi-Fi Trackpoints',
    'cEnrolleeAddresses': 'Addresses',
    'cEnrolleeVisits': 'Visits',
    'cEnrolleeVisitLabels': 'Visit Labels',
    'cEnrolleeVisitPoints': 'Visit Points',
    'cEnrolleeTrackPoints': 'Track Points',
    'cEnrolleeVisitAssociations': 'Visit With Associations',
	'cEnrolleeCellTowers': 'Cell Towers',
    'cEnrolleeWiFi': 'Wi-Fi',
    'cEnrolleeEMACheckIn': 'Enrollink',
    'cEnrolleeBluHomeV4': 'BLUHome V4',
	'cEnrolleeMapLabels': 'Map Labels',
    'cEnrolleeConnectedTracks': 'Connected Tracks',
    'cEnrolleeAlcoholTestPoints': 'SoberTrack Test',
    'cEnrolleeFrequentVisits': 'Frequently Visited Location',
    'cEnrolleeWeight': 'Weight',
    'cEnrolleeDeviceType': 'Device Type',
    'cEnrolleeGPS': 'GPS',
    'cEnrolleeRF': 'RF',
    'cEnrolleeST': 'ST',
    'cEnrolleeDaysInSchema':'Days in Field',
    'cEnrolleeTotalNumberOfTests':'Total Number of Tests',
    'cSelectAll': 'Select All',
    'cUnSelectAll': 'Unselect All',
    'cZoneGlobal': 'Global',
    'cZoneClassification': 'Classification',
    'cZoneRegular': 'Regular',
    'cZoneScopeRegular': 'Regular',
    'cZoneScopeGlobal': 'Global',
    'cBoth': 'Both',
    'cAll': 'All',
    'cEnrolleesMappingGPSCount': 'GPS Count',
    'cEnrolleesMappingCount': 'Count',
    'cEnrolleeGPSPoints': 'GPS Points',
    'cEnrolleeCurrentVisit': 'Current Visit',
    'cEnrolleeVisit': 'Visit',
    'cEnrolleeTotal': 'Total',
    'cEnrolleeNoTrackDataFilter': 'No track data available for current filter.',
    'cEnrolleeNoTrackData': 'No track data available.',
    'cAgentFeaturePreview': 'Feature Preview',
    'cEnrolleeCreateThreads': 'Create Threads',
    'cEnrolleeConfigureSettings': 'Configure',
    'cEnrolleeTimelineCreateLabel': 'Create Label',
    'cEnrolleeTimelineLabelSuggestions': 'Label Suggestions',
    'cTypes': 'Types',
    'cEnrolleeConfirm': 'Confirm',
    'cEnrolleeTimelineQuick': 'Timeline Details',
    'cEnrolleeMapEvents': 'Enrollee Map Events',
    'cEnrolleeMissingLabelName': 'Missing Label Name',
    'cEnrolleeZoneName': 'Zone Name',
    'cEnrolleeFullName': 'Enrollee Name',
    'cEnrolleeSuccessNewLabel': 'Successfully updated visit with label: ',
    'cReportSchedule': 'Schedule Report',
    'cReportScheduleDate': 'Schedule Date',
    'cReportScheduleTime': 'Schedule Time',
    'cReportTimeSpan': 'Time Span',
    'cReportEmailFormat': 'Email Format',
    'cReportDOC': ' DOC',
    'cReportPDF': 'PDF',
    'cReportXLS': 'XLS',
    'cReportRTF': ' RTF',
    'cReportTXT': 'TXT',
    'cReportCSV': 'CSV',
    'cReportsScheduleDaily': 'Schedule Date',
    'cReportsScheduleHourly': 'Schedule Time',
    'cReportsScheduleTimeSpan': 'Time Span',
    'cReportsScheduleName': 'Schedule Name',
    'cAgentEmails': 'Emails',
    'cAgentViewEmails': 'View Emails',
    'cAgentAddSchedule': 'Add Schedule',
    'cReportFilters': 'Filters',
    'cEnrolleeActive': 'Active',
    'cReportValue': 'Value',
    'cEnrolleeHasAssociation': 'Has Association',
    'cReportFindSchedules': 'Find Schedules',
    'cReportLabel': 'Label',
    'cReportScheduleEmailDetails': 'The Agent will get an email based on the schedule email format. But, if we need to send additional emails for the same report add them here.',
    'cReportScheduleDetails': 'Schedule Details',
    'cSuccessExclamation': 'Success!!!',
    'cReportAddScheduleEmailSuccess': 'Successfully added Email to Report Schedule distribution list.',
    'cReportDeleteScheduleEmailSuccess': 'Successfully deleted Email from Report Schedule.',
    'cReportEditScheduleEmailSuccess': 'Successfully updated Email on Report Schedule distribution list.',
    'cReportDeleteScheduleFilterSuccess': 'Successfully deleted Filter from Report Schedule.',
    'cEnrolleeSelectDay': 'Select Default Start Day View',
    'cEnrolleeDayofData': 'Select Default Day of Data View',
    'cAgentEditEmail': 'Edit Email',
    'cAgentAddEmail': 'Add Email',
    'cEnrolleeAllDay': 'All Day',
    'cReportSelectOrganization': 'Select Organization',
    'cReportScheduleFilterEdit': 'Most filters will default correcly based on the report and the time span settings. But, if you need to provide required filters or override default filters add them here.',
    'cReportEditFilter': 'Edit Filter',
    'cGoogleSuggested': 'Google Suggested',
    'cEnrolleeFrpFlagNeeded': 'To set a Daily Rate, Enrollee Pay must be enabled.',
    'cTimelineDuration': 'duration',
    'cTimelineHour': 'hour',
    'cTimelineHourPlural': 'hours',
    'cTimelineMinute': 'minute',
    'cTimelineMinutePlural': 'minutes',
    'cAnd': 'and',
    'cEnrolleePairedEnrollee': 'Paired Enrollee',
    'cPleaseSelect': 'Please select',
    'cKilograms': 'kilograms',
    'cPounds': 'pounds',
    'cOneHour': 'One Hour',
    'cThreeHour': 'Three Hours',
    'cSixHour': 'Six Hours',
    'cTwelveHour': 'Twelve Hours',
    'cOneDay': 'One Day',
    'cOneWeek': 'One Week',
    'cOneMonth': 'One Month',
    'cOlder': 'Older',
    'cAgentSMSEnabled': 'SMS Enabled',
    'cAgentSMSEnabledOn': 'Enabled',
    'c5min': '5 min',
    'c10min': '10 min',
    'c15min': '15 min',
    'c30min': '30 min',
    'c1hour': '1 hour',
    'c2hours': '2 hours',
    'c4hours': '4 hours',
    'c8hours': '8 hours',
    'c12hours': '12 hours',
    'c1day': '1 day',
    'c2days': '2 days',
    'c3days': '3 days',
    'c4days': '4 days',
    'c5days': '5 days',
    'c1week': '1 week',
    'cFindAnything': 'find anything',
    'cEventViewEvents': 'View Events',
    'cAddressGeocode': 'geocode',
    'cAbsence': 'Absence',
    'cAgentOffHoursDisabled': 'Off Hours Disabled',
    'cAgentThirdPhone': 'Third Phone',
    'cAgentFourthPhone': 'Fourth Phone',
    'cAgentDashboardUpdate': 'Dasboard Update',
    'cMissing': 'Missing',
    'cBroken': 'Broken',
    'cReturned': 'Returned',
    'cZoneShown': 'Shown',
    'cZoneHidden': 'Hidden',
    'cEnrolleeNewNote': '....new note',
    'cEnrolleePayBypassGeocode': 'Your FRP address does not geocode? Check this option to acknowledge that you are entering and saving an address that does not geocode but is still a valid bill to address.',
    'cEnrolleePlaying': 'Playing',
    'cEnrolleePaused': 'Paused',
    'cEnrolleeEnrollmentStart': 'Enrollment Start',
    'cEnrolleeEnrollmentEnd': 'Enrollment End',
    'cEnrolleeReleaseDate': 'Release Date',
    'cEnrolleeEmploymentDate': 'Employment Date',
    'cReportStatusNA': 'N/A',
    'cReportStatusUnprocessed': 'Unprocessed',
    'cReportStatusQueued': 'Queued',
    'cReportStatusProcessing': 'Processing',
    'cReportStatusProcessed': 'Processed',
    'cReportStatusError': 'error',
    'cReportOpenDocument': 'Open Document',
    'cEnrolleeCreateExclusionZone': 'Create Exclusion Zone',
    'cEnrolleeCreateInclusionZone': 'Create Inclusion Zone',
    'cEnrolleeEditExclusionZone': 'Edit Exclusion Zone',
    'cEnrolleeEditInclusionZone': 'Edit Inclusion Zone',
    'cEnrolleeSilent': 'Silent',
    'cEnrollee911': '911',
    'cTrue': 'true',
    'cFalse': 'false',
    'cDisabled': 'Disabled',
    'cEnabled': 'Enabled',
    'cZoneInclusionZone': 'Inclusion Zone',
    'cZoneExclusionZone': 'Exclusion Zone',
    'cTimelineConfirmed': 'Timeline Events Confirmed',
    'cEnrolleeMapEventConfirmed': 'Map Events Confirmed',
    'cDeviceDisableRapidReporting': 'Would you like to disable rapid reporting mode on this device?',
    'cDeviceDisableHaltRapidReporting': 'Would you like to disable halt rapid reporting mode on this device?',
    'cDeviceCurrentlyBuzz': 'This device is currently in buzz mode until ',
    'cDeviceCurrentlyVibrate': 'This device is currently in vibrate mode until ',
    'cDeviceCurrentlyLocateDevice': 'This device is currently in locate device mode until ',
    'cDeviceCurrentlyRapidReporting': 'This device is currently in rapid reporting mode until ',
    'cDeviceCurrentlyHaltRapidReporting': 'This device is currently in halt rapid reporting mode until ',
    'cDeviceCurrentlyBuzz': 'Your request to send a buzz command is currently being processed. ',
    'cDeviceCurrentlyVibrate': 'Your request to send a vibrate command is currently being processed. ',
    'cDeviceCurrentlyLocateDevice': 'Your request to send a locate device command is currently being processed. ',
    'cDeviceCurrentlyRapidReporting': 'Your request to send a rapid reporting command is currently being processed. ',
    'cDeviceCurrentlyHaltRapidReporting': 'Your request to send a halt rapid reporting command is currently being processed. ',
    'cDeviceMessageTimeoutBuzz': 'The device did not confirm that your previous request to send a buzz command was completed successfully. ',
    'cDeviceMessageTimeoutVibrate': 'The device did not confirm that your previous request to send a vibrate command was completed successfully. ',
    'cDeviceMessageTimeoutLocateDevice': 'The device did not confirm that your previous request to send a locate device command was completed successfully. ',
    'cDeviceMessageTimeoutRapidReporting': 'The device did not confirm that your previous request to send a rapid reporting command was completed successfully. ',
    'cDeviceMessageTimeoutHaltRapidReporting': 'The device did not confirm that your previous request to send a halt rapid reporting command was completed successfully. ',
    'cDeviceQuestion': 'device?',
    'cDeviceSendBuzz': 'Would you like to send a <strong>buzz</strong> command?',
    'cDeviceSendVibrate': 'Would you like to send a <strong>vibrate</strong> command?',
    'cDeviceSendLocateDevice': 'Would you like to send a <strong>locate device</strong> command?',
    'cDeviceSendRapidReporting': 'Would you like to send a <strong>rapid reporting</strong> command?',
    'cDeviceSendHaltRapidReporting': 'Would you like to send a <strong>halt rapid reporting</strong> command?',
    'cDeviceSendAgentFingerprintSetup': 'Would you like to send an <strong>agent fingerprint setup</strong> command?',
    'cDeviceSendCommand': 'Send Command',
    'cDeviceNoContact': '- no contact -',
    'cDeviceLastCommandSent': 'Last Command Sent',
    'cDeviceLastCommandReceived': 'Last Command Received',
    'cEnrolleeCreateAddress': 'Create Address',
    'cEnrolleeSupervisitionType': 'Supervision Type',
    'cEnrolleeReferralDate': 'Referral Date',
    'cEnrolleePrintedBy': 'Printed by',
    'cEnrolleeAssociationSummary': 'Association Summary',
    'cPrior': 'Prior',
    'cCurrent': 'Current',
    'cHistory': 'History',
    'cEnrolleeRightClickDetails': 'Right Click for more details',
    'cFinding': 'Finding.............',
    'cAnalysisAddressEnter': 'Enter any address, city/state',//, or latitude/longitude',
    'cEnrolleeAbsence24ScheduleName': '24 hours schedule name',
    'cEnrolleeAbsenceReason': 'absence reason',
    'cInventoryFindOrganization': 'Find Organization',
    'cInventoryTotalDevices': 'Total Devices',
    'cInventoryAssignedDevices': 'Assigned Devices',
    'cInventoryUnAssignedDevices': 'UnAssigned Devices',
    'cInventoryShippedDevices': 'Shipped Devices',
    'cInventoryReceivedDevices': 'Received Devices',
    'cInventoryReturnedDevices': 'Returned Devices',
    'cInventoryRecalledDevices': 'Recalled Devices',
    'cInventoryTrackSearchFailed': 'No trackpoints found for Device ',
    'cInventoryShelfRate': 'Shelf Rate',
    'cZoneInclusionZoneOverride': 'Inclusion Zone Override',
    'cEnrolleeScheduleCheckIn': 'Check-In',
    'cEnrolleeScheduleRecurringAbsence': 'Recurring Absence',
    'cEnrolleeScheduleSingleDayAbsence': 'Single Day Absence',
    'cEventHasAssociation': 'Has Association',
    'cEventBraceletStrap': 'Bracelet Strap',
    'cEventShieldingPossible': 'Shielding Possible',
    'cEventJammingPossible': 'Jamming Possible',
    'cEventNoGPS': 'No GPS',
    'cEnrolleesMappingGPSTrack': 'GPS Track',
	'cEnrolleesMappingCellTower': 'Cell Tower',
	'cEnrolleesMappingWiFi': 'Wi-Fi',
	'cEnrolleesMappingEMACheckIn': 'Enrollink',
	'cEnrolleesMappingCellTrack': 'Cell Track',
    'cEnrolleesHomeAddress': 'Home Address',
    'cEnrolleesWorkAddress': 'Work Address',
    'cEnrolleesOtherAddress': 'Other Address',
    'cEnrolleesTransientAddress': 'Transient Address',
    'cEnrolleesTetheredHomeAddress': 'Authorized Home Address',
    'cEnrolleesTetheredWorkAddress': 'Authorized Work Address',
    'cEnrolleesTetheredOtherAddress': 'Authorized Other Address',
    'cEnrolleesTetheredTransientAddress': 'Authorized Transient Address',
    'cEnrolleeInitialTimelineMapView': 'Initial Timeline Map View',
    'cAnalysisEnableEnrollee': 'enable enrollee',
    'cAnalysisDeleteEnrollee': 'delete enrollee',
    'cAutomatic': 'Automatic',
    'cManual': 'Manual',
    'cTripsVisits': 'Trips & Visits',
    'cTrackpoints': 'Trackpoints',
    'cAnalysisRerun': 'Rerun',
    'cAnalysisRerunSpatial': 'spatial query processing..............',
    'cEnrolleeTimelineFrequency': 'Visit Frequency',
    'cEnrolleeAttemptToRecover': 'Attempted to Recover by',
    'cInventoryAttemptedToRecover': 'Attempted to Recover',
    'cEnrolleeOffender': 'Enrollee',
    'cEnrolleeVictim': 'Victim',
    'cHistoricalIncident': 'Historical Incidents',
    'cAnalysisNewSearch': 'New Search',
    'cEnrolleeRefreshMapOnDateChange': 'Refresh Map On Day View Date Change',
    'cTimelineAlert': 'Enrollee is not supported on timeline.',
    'cZoneNoZoneSelected': 'No Zone Selected',
    'cZoneZoneNameFilter': 'Zone name filter',
    'cInventoryKnownLocations': 'Known Locations',
    'cEnrolleeQuickMap': 'Quick Map',
    'cEnrolleeTimelineDefaultTab': 'Right Click default tab',
    'cZoneLengthFive': '5 mi',
    'cZoneLengthTen': '10 mi',
    'cZoneLengthTwentyFive': '25 mi',
    'cZoneLengthFifty': '50 mi',
    'cInventoryShelfAnalysis': 'Shelf Analysis',
    'cAddressType': 'Address Type',
    'cKnownLocationDeleting': 'Deleting Known Location',
    'cKnownLocationSaving': 'Saving Known Location',
    'cIncidentAddNewSpatial': 'New Search Results - Add New Incident',
    'cInventoryFindShelfRate': 'Find Shelf Rate',
    'cShelfRateExceeded': 'Shelf Rate Exceeded',
    'cInventoryTotalBLUtags': 'Total BLUtags',
    'cInventoryAssignedBLUtags': 'Assigned BLUtags',
    'cInventoryUnAssignedBLUtags': 'Unassigned BLUtags',
    'cInventoryShelfRateBLUtag': 'BLUtag Shelf Rate',
    'cPotentialTrip': 'Potential Trip',
    'cEnrolleeScheduleSilent': 'Silent',
    'cEnrolleeSchedule911': '911',
    'cAnalysisNoOffendersFoundSpatial': 'No Enrollees found near spatial region with alert events',
    'cAnalysisNoAddressesFound': 'No Enrollee addresses found in spatial region',
    'cFailScheduleAddSelectFormat': 'Must Check Email Format Type',
    'cReportScheduleDeleting': 'Deleting Report Schedule',
    'cAgentExpiredPasswordInformation': 'Password Expired',
    'cAgentPasswordSameError': 'Password not changed. Please correct your information and try again.',
    'cAgentPasswordDuplicateError': 'Password has already been used, please type in different password.',
    'cAgentPasswordWeakError': 'Password is not strong enough, make sure it is at least 8 characters long, has 1 special character, 1 lower case, 1 upper case, and 1 digit.',
    'cAgentVeritracksWelcome': 'Welcome to VeriTracks, please fill in the required information.',
    'cAgentVeritracksInactive': 'Account inactivated due to not being used',
    'cAgentVeritracksExpired': 'Password Expired',
    'cAgentVeritracksReset': 'Password Reset by Administrator',
    'cAgentWhatIsStrongPassword': 'Please make sure the password is at least 8 characters long, has 1 special character, 1 lower case, 1 upper case, and 1 digit.',
    'cAgentPasswordInfo': 'If you would like to reset the password for this agent, you can auto generate the password by clicking the reset button with the "New Password" field blank or you can specify the password by typing the password in the "New Password" field.',
    'cAgentVeritracksWelcomeInfo': 'Welcome to VeriTracks, to start using the application please fill in the required information.',
    'cAgentVeritracksResetInfo': 'It looks like an administrator has reset your password, to continue using VeriTracks please set a new password',
    'cAgentVeritracksInactiveInfo': 'Welcome back to VeriTracks, it has been quite a while since you last logged in, please enter the correct answer to your security question and enter a new password to confirm your identity.',
    'cAgentVeritracksExpiredInfo': 'Your password has expired, please enter the correct answer to your security question and enter a new password to confirm your identity.',
    'cAgentSecurityAnswerError': 'Answer provided is incorrect.',
    'cAgentPasswordInformationSet': 'Security Information Set',
    'cAgentPasswordUpdated': 'Security Information Updated',
    'cPasswordExpireDaysRemaining': 'Your password will expire in',
    'cAgentGenerateCodes':'Generate',
    'cDays': 'days',
    'cDay': 'day',
    'cPasswordExpireDayToday': 'Your password will expire today',
    'cAgentPasswordPolicyEnforced': 'Password Policy Enforced',
    'cAgentPasswordPolicyDisabled': 'Password Policy Disabled',
    'cPasswordExpiredNotice': 'Your password has expired',
    'cEnrolleeNoCorrelateData' : 'No Association Data Found',
    'cEnrolleePrevious': 'Previous',
    'cEnrolleeNext': 'Next',
    'cSoberTrackLiveSchedule': 'Live Schedule',
    'cSoberTrackOnDemandCreate': 'On Demand Create',
    'cSoberTrackReport326': 'Report 326',
    'cSoberTrackRandomSaved': 'Random Schedule Has Been Saved',
    'cSoberTrackFixedSaved': 'Fixed Schedule Has Been Saved',
    'cSoberTrackOnDemandSaved': 'On Demand Event Sent',
    'cSoberTrackVideoRequestSent': 'Video Request Sent. Video will be available in a few minutes.',
    'cSoberTrackPassedDates': 'Please Select Upcoming Dates',
    'cEnrolleeDeleteEvent': 'Delete Event',
    'cSoberTrackEventDeleted': 'Scheduled Test Deleted',
    'cSoberTrackNoCreation': 'On Demand Create Not Allowed',
    'cSoberTrackOnDemandChange': 'On Demand Event Changed',
    'cSoberTrackOnDemandError': 'On Demand Test Error on Create',
    'cSoberTrackOnDemandTest': 'On Demand Test',
    'cSoberTrackRandomTest': 'Random Sobriety Event',
    'cSoberTrackFixedTest': 'Fixed Sobriety Event',
    'cSoberTrackFixedTestSave': 'Fixed Sobriety Event Saved',
    'cSoberTrackRandomSave': 'Random Sobriety Saved',
    'cSoberTrackNotSaved': 'Sobriety Not Saved',
    'cSoberTrackType': 'Type',
    'cSoberTrackDurationBetweenTests': 'Duration Between Tests',
    'cSoberTrackNumberTests': 'Number of Tests Per Block',
    'cSoberTrackTestPeriod': 'Check Period (min)',
    'cSoberTrackRetests': 'Number of Rechecks',
    'cSoberTrackPassed': 'Passed (Agent)',
    'cSoberTrackFailed': 'Failed (Agent)',
    'cSoberTrackNotValidated': 'Not Validated',
    'cSoberTrackRandomBlock': 'Random Sobriety Time Block',
    'cSoberTrackSelectedScheduleTypeSaved': 'Only Selected Schedule Type are Saved',
    'cSoberTrackNothingSaved': 'No New Events to Save',
    'cSoberTrackTitleLabel': 'SoberTrack Schedule Block Title',
    'cSoberTrackTitleChange': 'SoberTrack Title Change',
    'cSoberTrackRandomScheduleConflict': 'Random Block Not Saved: Scheduling Conflict',
    'cSoberTrackCreatingSchedules': 'Creating SoberTrack Schedules',
    'cSoberTrackReviewTitle': 'SoberTrack Monitoring Result',
    'cSoberTrackNoOverlap': 'SoberTrack Schedule Overlap Not Allowed',
    'cSoberTrackSaveFirst': 'Must Save Event Before Editing',
    'cSoberTrackTitle': 'Enrollee SoberTrack Test Schedule',
    'cEnrolleeConfirmReview': 'Confirm Review',
    'cEnrolleeGetVideo': 'Download Video',
    'cEnrolleeRetriedVideo': 'Retrieve Video',
    'cEnrolleeConfirmImageMatch': 'Image Matched',
    'cEnrolleeConfirmImageFail':'Image Failed',
    'cEnrolleeSoberTrackSetImageTry': 'Saving Enrollee Image...',
    'cEnrolleeSoberTrackSetImageSuccess': "Enrollee Image Saved",
    'cEnrolleeSoberTrackSetImageFail':'Enrollee Image failed',
    'cSoberTrackEventDragged': 'SoberTrack Schedule Dragged',
    'cEnrolleeTestSummary': 'back to confirmation',
    'cEnrolleePreviousSoberTrackResult': 'Previous Enrollee',
    'cEnrolleeNextSoberTrackResult':'Next Enrollee',
    'cSoberTrackSchedulePassesDay': 'Cannot Meet Schedule Rules in Day',
    'cSoberTrackScheduleBlocksSaved': 'SoberTrack Schedule Blocks Saved',
    'cEnrolleePrintAssociations': 'Print Associations',
    'cEnrolleeBirthDate': 'Birth Date',
    'cEnrolleeSchedulesNotSaved': 'All Schedule Blocks Not Saved Will Be Removed',
    'cAgentThisUsernameIsAlready': 'This username is already in use in our system. Please pick another.',
    'cSoberTrackDeleteBlock': 'Delete SoberTrack Schedule Block',
    'cSoberTrackEditNotValid': 'SoberTrack Title Not Valid',
    'cAgentSMSMessageUpdated': 'Successfully updated sms delivery number',
    'cAgentSMSMessageChanged': 'Successfully updated sms delivery option',
    'cAgentSMSMessageOptOut': 'Successfully opted out of sms delivery',
    'cAgentSMSMessageOptIn': 'Successfully opted in to sms delivery',
    'cSoberTrackEditNotValid': 'SoberTrack Title Not Valid',
    'cEnrolleeInvalidTimeFormat': 'Time Format is Invalid',
    'cSoberTrackNoBlocksToDelete': 'No SoberTrack Blocks Selected to Delete',
    'cSoberTrackSelectedForDelete': 'Schedule Block Selected for Delete',
    'cSoberTrackNotSelectedForDelete': 'Schedule Block Will Not be Deleted',
    'cCarveOutScheduleSelected': 'Schedule Block Selected',
    'cCarveOutScheduleNotSelected': 'Schedule Block Unselected',
    'cEnrolleeInvalidDateFormat': 'Date Format is Invalid',
    'cEventHasAssociationKnownLocation': 'Has Known Location Association',
    'cUserUpdatedBy': 'Updated By',
    'cSoberTrackSchedules': 'SoberTrack Schedules',
    'cSoberTrackStartHour': 'Start Hour',
    'cSoberTrackStopHour': 'Stop Hour',
    'cSoberTrackConfirmed': 'Confirmed',
    'cSoberTrackDayOfWeek': 'Day of Week',
    'cUserAgreementDecline': 'Decline',
    'cUserAgreementAccept': 'Accept',
    'cSoberTrackSaveFirstAfterDrag': 'Must Save Event After Dragging Before Editing',
    'cEnrolleeSMSPhoneNumber': 'Phone Number',
    'cZoneEnrolleeCount': 'Enrollee Count',
    'cAgentFingerprintSetup': 'Agent Fingerprint Setup',
    'cStalkerPreventUnassignUnPair':'Enrollee is currently paired to Victim(s): %s.  Unassigning the enrollee will also unpair and unregister the Victim from Stalker Alert.  Do you wish to proceed?',
    'cStalkerPreventUnassignKeepPair':'Device is currently paired with a Victim(s): %s. Changing device will unpair the victim and will require for you to go to the Victim Profile to reassign to enrollee.  Do you wish to continue?',
    'cStalkerDisableEnrollee':'Warning: Disabling Stalker Mobile App will remove all configurations for this Victim.  Click "ok" to proceed.',
    'cStalkerORIChange':'Changing the ORI will un-pair the current paired  %s.',
    'cDoYouWishToProceed':' Do you wish to proceed?',
    'cStalkerAlertMobile':'Stalker Alert Mobile',
    'cEnterEnrollee': 'Enter an enrollee',
    'cEnterReportName': 'Enter an Report name',
    'cUnsupportedEmail': 'Email based SMS is not supported. Please enter a proper email.',
    'cConfirmationTitle': 'Confirmation', 
    'cAgentRolePermissionsConfirmation': 'Agent permission will be affected if roles are changed.',
    'cAcknowledge': 'Acknowledge',
    'cAgentTrackReviewAgreement':'You have reached the end of the track playback review. Please click "Accept" to verify.'
};
////// remove comments below to use lorem text
//var l = new Lorem;
//l.type = Lorem.TEXT;
//l.query = '1w';
//for (var lKey in locale) {
//    locale[lKey] = l.createLorem();
//}
